<template>
  <div>
    <Nav :currentActive="'MID'" />
    <!-- <ScaleBox> -->
      <div class="mid-container">
        <div class="banner-warp">
          <img src="@/assets/MID/banner-image.png" class="banner-img" alt="">
          <div class="banner-content">
            <div class="banner-title">一站式数据追溯平台</div>
            <div class="banner-sub">
              模型能力拓展
              <span class="line"></span>
              专业算法服务
              <span class="line"></span>
              安全可信会话无痕
              <span class="line"></span>
              高并发算力保障
            </div>
            <div class="banner-btn">
              <span class="btn-primary">立即体验</span>
              <span class="btn-custom">控制台</span>
            </div>
          </div>
        </div>
        <div class="title-warp">
          <div class="title-item ml10">
            <div class="item-h4">标签工艺</div>
            <div class="item-sub">一物一码</div>
          </div>
          <div class="title-item">
            <div class="item-h4">定价与收费</div>
            <div class="item-sub">标签定价与计费方式</div>
          </div>
          <div class="title-item">
            <div class="item-h4">资质验证</div>
            <div class="item-sub">满足可信与合规需求</div>
          </div>
          <div class="title-item">
            <div class="item-h4">帮助文档</div>
            <div class="item-sub">快速入门使用</div>
          </div>
        </div>
        <div class="label-warp">
          <div class="label-title">
            <div class="label-h3">防伪标签工艺</div>
            <div class="label-sub">一物一码，全程溯源，终极防伪保护品牌权益</div>
          </div>
          <div class="label-content">
            <img src="@/assets/MID/label-line.png" class="label-img" alt="">
            <span class="label-tip" 
              v-for="(item,index) in labelList"
              :key="index + 'll'"
              :style="{'--left':item.left,'--top':item.top,'--color':item.color}">
              {{ item.title }}
            </span>
          </div>
        </div>
        <div class="supply-warp">
          <div class="supply-title">供应链流程追溯</div>
          <div class="supply-content">
            <div class="supply-content-title">
              <div class="supply-h3">供应链流程结构图</div>
              <div class="supply-sub">全流程细节可追溯</div>
            </div>
            <div class="supply-content-warp">
              <img src="@/assets/MID/supply-img.png" class="supply-img" alt="">
              <span class="supply-tip" :class="item.fs ?'':'fs16'" 
                v-for="(item,index) in supplyList" :key="index +'sl'"
                :style="{'--left':item.left,'--top':item.top}">
                {{ item.title }}
              </span>
            </div>
            
          </div>
        </div>
        <div class="brand-warp">
          <div class="brand-title">
            <div class="brand-h4">品牌中心</div>
            <div class="brand-sub">多种优质/可定制标签码</div>
          </div>
          <div class="brand-content">
            <div class="brand-left">
              <div class="brand-item" :class="activeIndex==index?'brand-active':''" 
                v-for="(item,index) in brandList" :key="index+'bl'" @click="activeIndex = index">
                <div class="left-h4">{{ item.title }}</div>
                <div class="left-tip">{{ item.tip }}</div>
              </div>
            </div>
            <div class="brand-right">
              <img src="@/assets/MID/brand-mark.png" alt="" class="brand-mark">
              <img src="@/assets/MID/brand-img.png" alt="" class="brand-img">
            </div>
          </div>
        </div>
        <div class="map-warp">
          <div class="map-title">全球数源服务覆盖</div>
          <div class="map-sub">构建新型国际贸易规则，为实现法治化、市场化、国际化的国际贸易环境奠定坚实基础</div>
          <div class="map-point">
            <span class="point-line" 
              v-for="(item,index) in pointList" :key="index+'pl'" 
              :style="{'--left':item.left,'--top':item.top}">
              <span class="point"></span>
            </span>
          </div>
        </div>
        <div class="flair-warp">
          <div class="flair-title">
            <div class="flair-h4">资质与认证</div>
            <div class="flair-sub">通过多项资质认证，满足可信与合规需求</div>
          </div>
          <div class="flair-content" :class="isMore?'auto':''">
            <div class="flair-item" v-for="(item,index) in flairList" :key="index+'fl'">
              <img :src="item.img" alt="" class="flair-img">
              <div class="item-right">
                <div class="right-title">{{ item.title }}</div>
                <div class="right-btn">
                  <span class="btn">隐私</span>
                  <span class="btn">合规</span>
                </div>
                <div class="right-tip">{{ item.tip }}</div>
              </div>
            </div>
            
          </div>
          <div class="flair-more" v-if="flairList.length>12" @click="isMore = !isMore">
            {{isMore?'收起':'展开更多'}}
            <img src="@/assets/MID/arrow-down.png" alt="" class="icon" >
          </div>
        </div>
        <div class="bottom-warp"> 
          <div class="bottom-title">MID品牌聚合平台，追溯数据全覆盖</div>
          <span class="bottom-btn" @click="handleContacts">立即咨询</span>
        </div>
        <Footer /> 
      </div>
    <!-- </ScaleBox> -->
    <div class="fix-right">
      <div class="fix-top">
        <div class="pre-sales" @click="handleContacts">
          <img src="@/assets/MID/pre-icon.png" alt="" class="pre-icon">
          <span class="p17">售前咨询</span>
        </div>
        <!-- <div class="after-sales">
          <img src="@/assets/MID/after-icon.png" alt="" class="after-icon">
          售后
        </div>
        <div class="active-sales">
          <img src="@/assets/MID/active-icon.png" alt="" class="active-icon">
          活动
        </div> -->
      </div>
      <div class="fix-bottom" @click="handleTop">
        <img src="@/assets/MID/top-icon.png" alt="" class="top-icon">
      </div>
    </div>
    <el-dialog
        v-model="dialogVisible"
        title="咨询"
        width="600"
      >
      <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="auto">
        <el-form-item label="企业名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入企业全称" />
        </el-form-item>
        <el-form-item label="联系人" prop="contacts">
          <el-input v-model="ruleForm.contacts" placeholder="请留下您的大名" />
        </el-form-item>
        <el-form-item label="联系方式" prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请留下您的联系方式，以便第一时间服务您" />
        </el-form-item>
        <el-form-item label="需求描述" prop="remark">
          <el-input v-model="ruleForm.remark" type="textarea" placeholder="请留下您的需求，我们会第一时间回复您，感谢！" />
        </el-form-item>
        
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">
            提交
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import ScaleBox from './ScaleBox.vue';
import Nav from '../../components/NavTop.vue';
import Footer from '../../components/Footer.vue';
const containerRef = ref([]);
const isMore = ref(false);
const labelList = ref([
  {left:'0%',top:'-7%',color:'#0C0D0E',title:'全息浮雕技术'},
  {left:'0%',top:'64%',color:'#0C0D0E',title:'全息彩虹技术'},
  {left:'79%',top:'-1%',color:'#fff',title:'AI霓彩双效防伪技术'},
  {left:'87%',top:'31%',color:'#fff',title:'彩色随机颗粒'},
  {left:'86%',top:'89%',color:'#fff',title:'可追溯二维码'}
])
const supplyList = ref([
  {left:'9%', top:'7%', title:'上游',fs:true},
  {left:'48%', top:'7%', title:'中游',fs:true},
  {left:'87%', top:'7%', title:'下游',fs:true},
  {left:'8.5%', top:'36.5%', title:'原料产地',fs:''},
  {left:'8.5%', top:'66.5%', title:'原料采购',fs:''},
  {left:'18.5%', top:'21%', title:'物流运输',fs:''},
  {left:'18.5%', top:'48.5%', title:'物流配送',fs:''},
  {left:'18.5%', top:'80.5%', title:'物流配送',fs:''},
  {left:'28.5%', top:'36.5%', title:'原料入库',fs:''},
  {left:'28.5%', top:'66.5%', title:'产品入库',fs:''},
  {left:'38%', top:'48.5%', title:'生产厂商',fs:''},
  {left:'38.5%', top:'79.5%', title:'销售订单',fs:''},
  {left:'47.5%', top:'66.5%', title:'入库/库存',fs:''},
  {left:'57%', top:'21%', title:'生产制造',fs:''},
  {left:'57%', top:'48.5%', title:'订单流转',fs:''},
  {left:'57%', top:'79%', title:'标签贴码',fs:''},
  {left:'68%', top:'36.5%', title:'流水线订单',fs:''},
  {left:'68%', top:'66.5%', title:'产品出库',fs:''},
  {left:'77%', top:'21%', title:'门店批发',fs:''},
  {left:'77%', top:'79.5%', title:'客户下单',fs:''},
  {left:'86%', top:'36.5%', title:'经销商订单',fs:''},
  {left:'86%', top:'66.5%', title:'终端客户签收',fs:''}
])
const pointList = ref([
  {left:'8.5%', top:'13%'},
  {left:'18%', top:'28%'},
  {left:'24%', top:'76%'},
  {left:'39%', top:'26%'},
  {left:'56%', top:'44%'},
  {left:'47%', top:'76%'},
  {left:'78%', top:'31%'},
  {left:'79%', top:'39%'},
  {left:'82%', top:'57%'},
  {left:'88%', top:'69%'}
])
const brandList = ref([
  {
    title:'澳优码',tip:'具有海量资源储备，保障复杂计算高效运行'
  },
  {
    title:'梧字标',tip:''
  },
  {
    title:'金优码',tip:''
  },
  {
    title:'放心茶',tip:''
  },
  {
    title:'文创码',tip:''
  },
])
const activeIndex = ref(0)
const dialogVisible = ref(false)
const ruleForm= ref({})
const ruleFormRef= ref()
const rules = ref({
  name:[{ required: true, message: '请输入企业全称', trigger: 'blur' },],
  contacts:[{ required: true, message: '请输入联系人', trigger: 'blur' },],
  phone:[{ required: true, message: '请输入联系方式', trigger: 'blur' },],
  remark:[{ required: true, message: '请输入需求描述', trigger: 'blur' },],
})
const flairList = ref([
  {
    img:require('@/assets/MID/flair-logo1.png'),
    title:'SOC 1/2/3',
    tip:'云服务安全可靠、稳定可用，满足第三方审计机构的AICPA可信服务标准'
  },
  {
    img:require('@/assets/MID/flair-logo1.png'),
    title:'CSA STAR',
    tip:'服务安全性获得国际标准认可'
  },
  {
    img:require('@/assets/MID/flair-logo1.png'),
    title:'ISO 27001',
    tip:'信息安全管理体系认证'
  },
  {
    img:require('@/assets/MID/flair-logo1.png'),
    title:'ISO 27017',
    tip:'云服务安全管理能力认证'
  },
  {
    img:require('@/assets/MID/flair-logo1.png'),
    title:'ISO 27018',
    tip:'个人信息保护管理体系认证'
  },
  {
    img:require('@/assets/MID/flair-logo1.png'),
    title:'ISO 9001',
    tip:'质量管理体系认证'
  },
  {
    img:require('@/assets/MID/flair-logo1.png'),
    title:'ISO 22301',
    tip:'业务连续性管理能力认证'
  },
  {
    img:require('@/assets/MID/flair-logo1.png'),
    title:'ISO 27701',
    tip:'隐私合规体系认证'
  },
  {
    img:require('@/assets/MID/flair-logo1.png'),
    title:'ISO 29151',
    tip:'隐私保护控制能力认证'
  },
  {
    img:require('@/assets/MID/flair-logo1.png'),
    title:'ISO 14001',
    tip:'企业社会责任认证，环境安全'
  },
  {
    img:require('@/assets/MID/flair-logo1.png'),
    title:'ISO 45001',
    tip:'企业社会责任认证，职业健康安全'
  },
  {
    img:require('@/assets/MID/flair-logo1.png'),
    title:'ISO 27040',
    tip:'数据存储安全认证'
  },
  {
    img:require('@/assets/MID/flair-logo1.png'),
    title:'ISO 45001',
    tip:'企业社会责任认证，职业健康安全'
  },
  {
    img:require('@/assets/MID/flair-logo1.png'),
    title:'ISO 27040',
    tip:'数据存储安全认证'
  },
])
const handleTop = ()=>{
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // 启用平滑滚动
  });
}
const handleContacts = ()=>{
  dialogVisible.value = true;
  nextTick(()=>{
    ruleFormRef.value.resetFields()
  })
}
const handleSubmit = ()=>{
  ruleFormRef.value.validate((valid) => {
    if (valid) {
      dialogVisible.value = false
    } 
  })
}
</script>

<style lang="scss" scoped>
.mid-container {
  font-family: PingFang SC, PingFang SC;
  padding-top: 84px;
  color: #fff;
  background-color: #f7f9fc;
  position: relative;
  .banner-warp{
    height: 740px;
    background: url('@/assets/MID/banner-bg.png') no-repeat center center;
    background-size: 100% 100%;
    position: relative;
    .banner-img{
      width: 480px;
      height: 480px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
    }
    .banner-content{
      position: absolute;
      left: 12%;
      top: 50%;
      transform: translate(0,-40%);
      .banner-title{
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 56px;
        line-height: 56px;
        
      }
      .banner-sub{
        display: flex;
        align-items: center;
        margin: 30px 0 60px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: rgba(255,255,255,0.8);
        .line{
          display: block;
          width: 1px;
          height: 17px;
          background-color: rgba(255,255,255,0.8);
          margin: 0 16px;
        }
      }
      .banner-btn{
        display: flex;
        align-items: center;
        .btn-primary{
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 16px;
          width: 158px;
          height: 48px;
          background: linear-gradient( 96deg, #1664FF 0%, #7624FF 98%);
          box-shadow: 0px 6px 8px 0px rgba(46,70,146,0.1);
          border-radius: 4px 4px 4px 4px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: rgba(255,255,255,0.8);
          cursor: pointer;
        }
        .btn-custom{
          display: flex;
          align-items: center;
          justify-content: center;
          width: 158px;
          height: 48px;
          background: rgba(255,255,255,0.8);
          box-shadow: 0px 3px 8px 0px rgba(46,70,146,0.15);
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #F3F3F3;
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #101010;
          cursor: pointer;
        }
      }
    }
  }
  .title-warp{
    height: 94px;
    display: flex;
    .title-item{
      width: 25%;
      display: flex;
      flex-direction: column;
      // align-items: center;
      justify-content: center;
      margin-left: 5%;
      .item-h4{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #020814;
        margin-bottom: 5px;
      }
      .item-sub{
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #41464F;
      }
    }
    .ml10{
      margin-left: 10%;
    }
  }
  .label-warp{
    height: 737px;
    background: url('@/assets/MID/label-bg.png') no-repeat center center;
    background-size: 100% 100%;
    position: relative;
    .label-title{
      position: absolute;
      left: 50%;
      top: 8%;
      transform: translate(-50%,0);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .label-h3{
        font-weight: 600;
        font-size: 40px;
        color: #181818;
        margin-bottom: 17px;
      }
      .label-sub{
        font-weight: 400;
        font-size: 16px;
        color: #4E5969;
      }
    }
    .label-content{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-36%);
      .label-img{
        width: 1104px;
        height: 378px;
      }
      .label-tip{
        font-weight: 500;
        font-size: 20px;
        position: absolute;
        left: var(--left);
        top: var(--top);
        color:var(--color) ;
      }
    }
    
  }
  .supply-warp{
    margin-top: 61px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .supply-title{
      margin-bottom: 61px;
      font-weight: 600;
      font-size: 40px;
      color: #181818;
    }
    .supply-content{
      box-sizing: border-box;
      padding: 37px 32px;
      background: #fff;
      .supply-content-title{
        margin-bottom: 20px;
        .supply-h3{
          font-weight: 500;
          font-size: 32px;
          color: #0C0D0E;
          margin-bottom: 12px;
        }
        .supply-sub{
          font-weight: 400;
          font-size: 14px;
          color: #4E5969;
        }
      }
      
      .supply-content-warp{
        position: relative;
        .supply-img{
          width: 1376px;
          height: 530px;
        }
        .supply-tip{
          font-weight: 500;
          font-size: 24px;
          position: absolute;
          // opacity: 0;
          // transform: translateY(20px);
          // animation: textLoop 4s infinite; /* 总动画时长 */
          left: var(--left);
          top: var(--top);
        }
        .fs16{
          font-size: 16px;
        }
      }
    }
  }
  .brand-warp{
    .brand-title{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 121px 0 64px;
      .brand-h4{
        font-weight: 600;
        font-size: 40px;
        color: #181818;
        margin-bottom: 17px;
      }
      .brand-sub{
        font-weight: 400;
        font-size: 16px;
        color: #4E5969;
      }
    }
    .brand-content{
      width: 80%;
      margin: 0 auto 85px;
      display: flex;
      .brand-left{
        width: 30%;
        border-left: 1px solid #B2B2B2;
        .brand-item{
          box-sizing: border-box;
          padding: 0 26px;
          height: 106px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          cursor: pointer;
          .left-h4{
            font-weight: 400;
            font-size: 24px;
            color: #5D5D5D;
          }
          .left-tip{
            font-weight: 400;
            font-size: 14px;
            color: #4E5969;
          }
        }
        .brand-active{
          border-left: 2px solid #181818;
          .left-h4{
            font-weight: 500;
            font-size: 28px;
            color: #181818;
          }
        }
      }
      .brand-right{
        width: 70%;
        position: relative;
        .brand-mark{
          width: 100%;
          height: 486px;
          position: absolute;
          left: 0;
          bottom: 0;
          z-index: 0;
        }
        .brand-img{
          width: 100%;
          height: 572px;
        }
      }
    }
  }
  .map-warp{
    height: 824px;
    background: url('@/assets/MID/map-bg.png') no-repeat center center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .map-title{
      font-weight: 600;
      font-size: 40px;
      margin-top: 81px;
    }
    .map-sub{
      margin-top: 17px;
      font-weight: 400;
      font-size: 16px;
      color: rgba(255,255,255,0.8);
    }
    .map-point{
      width: 60%;
      height: 70%;
      position: relative;
      .point-line{
        position: absolute;
        left: var(--left);
        top: var(--top);
        width: 30px;
        height: 30px;
        background: rgba(22,100,255,0.1);
        box-shadow: inset 0px 0px 4px 2px #1664FF;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        animation: blink 1.5s infinite ease-in-out;
        .point{
          width: 10px;
          height: 10px;
          background: #1664FF;
          border-radius: 50%;
          animation: blink 1.5s infinite ease-in-out;
        }
      }
    }
  }
  .flair-warp{
    .flair-title{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 81px 0 80px;
      .flair-h4{
        font-weight: 600;
        font-size: 40px;
        color: #181818;
        margin-bottom: 17px;
      }
      .flair-sub{
        font-weight: 400;
        font-size: 16px;
        color: #4E5969;
      }
    }
    .flair-content{
      width: 80%;
      height: calc((160px + 28px) *4);
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      .flair-item{
        box-sizing: border-box;
        width: 31%;
        height: 160px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #EAEDF1;
        color: #41464F;
        display: flex;
        padding: 25px;
        margin:0 28px 28px 0;
        .flair-img{
          width: 72px;
          height: 72px;
          margin-right: 24px;
        }
        .item-right{
          .right-title{
            font-weight: 500;
            font-size: 18px;
            color: #020814;
          }
          .right-btn{
            display: flex;
            .btn{
              display: flex;
              align-items: center;
              justify-content: center;
              width: 38px;
              height: 20px;
              border-radius: 2px 2px 2px 2px;
              border: 1px solid #E5E5E6;
              font-weight: 400;
              font-size: 12px;
              color: #4E5969;
              margin:11px 8px 17px 0;
            }
          }
        }
      }
    }
    .auto{
      height: auto;
      overflow: auto;
    }
    .flair-more{
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 14px;
      color: #41464F;
      margin-bottom: 83px;
      cursor: pointer;
      .icon{
        width: 14px;
        height: 14px;
        margin-left: 5px;
      }
    }
  }
  .bottom-warp{
    height: 277px;
    background: url('@/assets/MID/bottom-img.png') no-repeat center center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .bottom-title{
      font-weight: 500;
      font-size: 36px;
      color: #181818;
      margin-bottom: 28px;
    }
    .bottom-btn{
      width: 140px;
      height: 56px;
      background: #1664FF;
      border-radius: 4px 4px 4px 4px;
      font-weight: 500;
      font-size: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
}
.fix-right{
  position: fixed;
  z-index: 999;
  right: 24px;
  top: 50%;
  transform: translate(0,-50%);
  
  .fix-top{
    background-color: #fff;
    width: 48px;
    border-radius: 48px;
    .pre-sales{
      height: 138px;
      box-sizing: border-box;
      padding: 17px 0 5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      background-color: #2c60ff;
      border-radius: 48px;
      line-height: 16px;
      color: #fff;
      cursor: pointer;
      img{
        width: 21px;
        height: 21px;
      }
      .p17{
        padding: 17px;
      }
    }
    .after-sales,
    .active-sales{
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      color: #41464F;
      img{
        width: 21px;
        height: 21px;
      }
    }
    .after-sales{
      margin: 30px 0 12px;
    }
    .active-sales{
      padding-bottom: 17px;
    }
  }
  .fix-bottom{
    width: 48px;
    height: 48px;
    background-color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 12px;
    cursor: pointer;
    .top-icon{
      width: 24px;
      height: 24px;
    }
  }
  
}
@keyframes textLoop {
  0% {
    opacity: 0;
    transform: translateY(20px); /* 起始位置 */
  }
  15% {
    opacity: 1;
    transform: translateY(0); /* 完全显示 */
  }
  85% {
    opacity: 1; /* 保持可见状态 */
  }
  100% {
    opacity: 0;
    transform: translateY(-20px); /* 向上淡出 */
  }
}

/* 定义闪烁动画 */
@keyframes blink {
  0%, 100% {
    // border-color: #2196F3; /* 原始颜色 */
    transform: scale(0.8);
  }
  50% {
    // border-color: rgba(33, 150, 243, 0.1); /* 半透明状态 */
    transform: scale(1); /* 可选缩放效果 */
  }
}
</style>